import {triggerEvent} from '../utils/tracking';

const $ = window.jQuery;

/**
 * Enables 'MWB WooCommerce Tracking' plugin specific scripting
 */
const WooCommerceTracking = {

    /**
     * Initialise functionality
     */
    init()
    {
        this.bindRemoveCartItemEvents();
    },

    /**
     * Get the list of cart items prepared for events
     */
    getCartItems()
    {
        return scriptVars.plugins.woocommerceTracking.cartItems || [];
    },

    /**
     * Get the current currency code
     */
    getCurrency()
    {
        return scriptVars.plugins.woocommerceTracking.currency || null;
    },

    /**
     * Bind events that inform of a cart item being removed
     */
    bindRemoveCartItemEvents()
    {
        $(document.body).
        on('removed_from_cart',
            (a, b, c, $el) => this.handleRemoveFromCart($el.data('cart_item_key')));
        $(document).
        on('click', '.woocommerce-cart-form .product-remove > a',
            (e) => this.handleRemoveFromCart(
                $(e.currentTarget).data('cart_item_key')));
    },

    /**
     * Handle removing item from cart
     *
     * @param {string} cartItemKey Cart item key of item being removed
     */
    handleRemoveFromCart(cartItemKey)
    {

        // Abort if unable to find cart item
        const cartItem = this.getCartItems()[cartItemKey] || false;
        if (!cartItem) {
            console.error('Unable to find cart item for "remove" event');
            return;
        }

        // Trigger event
        triggerEvent({
            event: 'remove_from_cart', ecommerce: {
                'currency': this.getCurrency(),
                'value': cartItem.price || null,
                'items': [cartItem],
            },
        }, 'ecommerce');

    },

};

export default WooCommerceTracking;